// extracted by mini-css-extract-plugin
export default {"stratagyTitle":"cardStratagy_stratagyTitle__i8Z4k"};